module.exports = __webpack_public_path__ + "static/media/dashboard.active.b2d64fe1.svg";